// extracted by mini-css-extract-plugin
export default {"wrapper":"rt-z","response":"st-z","error":"tt-z","disabled":"ut-z","buttons":"vt-z","feedbackQuestionSection":"wt-z","yesNoWrapper":"xt-z"};